module.exports = __webpack_public_path__ + "media/images/1200/CBD_facts_woman_on_bed-a687be4ecef9dacb9773c87332bd4ed3.webp";